import type { ScoopStatus } from "@/types";

const styles: Record<ScoopStatus, string> = {
  已核实: "bg-secondary-100 text-secondary-800 border-secondary-300",
  核实中: "bg-accent-100 text-accent-900 border-accent-300",
  多方求证: "bg-primary-100 text-primary-800 border-primary-200",
  待补充: "bg-background-200 text-foreground-700 border-background-300",
};

export default function StatusBadge({ status }: { status: ScoopStatus }) {
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[11px] font-medium ${styles[status]}`}
    >
      <i className="ri-shield-star-line text-xs" aria-hidden="true"></i>
      {status}
    </span>
  );
}